var map = {
	"./2CAD.svg": 724,
	"./2JPY.svg": 725,
	"./2NZD.svg": 726,
	"./2OMB.png": 727,
	"./2SGD.png": 728,
	"./2SHARES.png": 729,
	"./4EUR.png": 730,
	"./AAVE.svg": 731,
	"./AAVEe.svg": 732,
	"./ACRE.png": 733,
	"./ADA.svg": 734,
	"./ADX.svg": 735,
	"./ALI.svg": 736,
	"./ALPACA.png": 737,
	"./ALPHA.png": 738,
	"./AMPL.png": 739,
	"./ANN.png": 740,
	"./ANY.png": 741,
	"./AOT.png": 742,
	"./APE.png": 743,
	"./ARBITRUM.svg": 744,
	"./ATLAS.png": 745,
	"./ATOM.png": 746,
	"./AURO.png": 747,
	"./AURORA.svg": 748,
	"./AVALANCHE.svg": 749,
	"./AVAX.png": 750,
	"./AVAX.svg": 751,
	"./AVAXL.svg": 752,
	"./AXS.png": 753,
	"./Andromeda.svg": 754,
	"./BABY.svg": 755,
	"./BABYCAKE.svg": 756,
	"./BAKE.png": 757,
	"./BALL.png": 758,
	"./BANANA.svg": 759,
	"./BASED.svg": 760,
	"./BCH.svg": 761,
	"./BCT.png": 762,
	"./BDO.png": 763,
	"./BDP.png": 764,
	"./BEAR.png": 765,
	"./BEETS.png": 766,
	"./BETA.svg": 767,
	"./BETH.png": 768,
	"./BETU.png": 769,
	"./BHC.png": 770,
	"./BICO.png": 771,
	"./BIFI.png": 772,
	"./BISON.png": 773,
	"./BLZZ.svg": 774,
	"./BMON.svg": 775,
	"./BNB.png": 776,
	"./BNBbsc.png": 777,
	"./BOMB.png": 778,
	"./BONE.png": 779,
	"./BONEswap.png": 780,
	"./BOO.png": 781,
	"./BOOK.png": 782,
	"./BORING.png": 783,
	"./BP.png": 784,
	"./BPT.png": 785,
	"./BREW.png": 786,
	"./BRIBE.png": 787,
	"./BRUSH.png": 788,
	"./BSC.svg": 789,
	"./BSCDEFI.svg": 790,
	"./BSCPAD.png": 791,
	"./BSHARE.svg": 792,
	"./BSTN.svg": 793,
	"./BSW.svg": 794,
	"./BTC.svg": 795,
	"./BTCB.svg": 796,
	"./BTD.png": 797,
	"./BTS.png": 798,
	"./BTT.png": 799,
	"./BUNNY.png": 800,
	"./BURGER.png": 801,
	"./BUSD.svg": 802,
	"./BUSDe.svg": 803,
	"./BUSM.png": 804,
	"./BYTE.png": 805,
	"./CAKE.svg": 806,
	"./CAPS.svg": 807,
	"./CARROT.png": 808,
	"./CCAR.png": 809,
	"./CEEK.png": 810,
	"./CEL.png": 811,
	"./CELO.svg": 812,
	"./CHARGE.png": 813,
	"./CHARM.svg": 814,
	"./CHESS.svg": 815,
	"./CLAM.png": 816,
	"./CLY.png": 817,
	"./COOK.png": 818,
	"./CRA.png": 819,
	"./CRAFT.png": 820,
	"./CRE8R.png": 821,
	"./CREAM.svg": 822,
	"./CRO.svg": 823,
	"./CRONA.svg": 824,
	"./CRONOS.svg": 825,
	"./CRUSH.svg": 826,
	"./CRV.png": 827,
	"./CRYSTL.png": 828,
	"./CTK.png": 829,
	"./CYT.png": 830,
	"./CZF.png": 831,
	"./DAI.png": 832,
	"./DAI.svg": 833,
	"./DAIe.png": 834,
	"./DAR.svg": 835,
	"./DARK.svg": 836,
	"./DBY.png": 837,
	"./DCAU.png": 838,
	"./DEG.png": 839,
	"./DEI.png": 840,
	"./DELIRIUM.png": 841,
	"./DEP.png": 842,
	"./DEUS.png": 843,
	"./DFYN.png": 844,
	"./DG.png": 845,
	"./DIBS.png": 846,
	"./DINO.png": 847,
	"./DIS.svg": 848,
	"./DKT.png": 849,
	"./DOGE.svg": 850,
	"./DOLA.png": 851,
	"./DOMI.png": 852,
	"./DOT.png": 853,
	"./DPI.png": 854,
	"./DPT.png": 855,
	"./DRUGS.png": 856,
	"./DSHARE.png": 857,
	"./DUET.svg": 858,
	"./DVI.svg": 859,
	"./ECD.png": 860,
	"./EGG.png": 861,
	"./ELK.png": 862,
	"./ELON.png": 863,
	"./EMERALD.png": 864,
	"./EMP.png": 865,
	"./EPS.png": 866,
	"./ERA.svg": 867,
	"./ERTHA.png": 868,
	"./ESHARE.png": 869,
	"./EST.png": 870,
	"./ETERNAL.png": 871,
	"./ETH.svg": 872,
	"./ETH2x.png": 873,
	"./ETHs.svg": 874,
	"./EURt.png": 875,
	"./EXP.svg": 876,
	"./EZ.png": 877,
	"./FANTOM.svg": 878,
	"./FET.png": 879,
	"./FFF.png": 880,
	"./FIEF.png": 881,
	"./FIL.svg": 882,
	"./FINN.png": 883,
	"./FIRE.png": 884,
	"./FISH.svg": 885,
	"./FITFI.png": 886,
	"./FLARE.png": 887,
	"./FLX.png": 888,
	"./FLY.png": 889,
	"./FODL.png": 890,
	"./FONT.png": 891,
	"./FOO.png": 892,
	"./FORM.svg": 893,
	"./FOX.png": 894,
	"./FRAX.svg": 895,
	"./FRM.png": 896,
	"./FROYO.png": 897,
	"./FRUIT.png": 898,
	"./FS.png": 899,
	"./FTM.png": 900,
	"./FTML.svg": 901,
	"./FUSD.png": 902,
	"./FUSE Network.svg": 903,
	"./FUSE.svg": 904,
	"./FXS.png": 905,
	"./G.png": 906,
	"./GAL.png": 907,
	"./GEIST.svg": 908,
	"./GEL.png": 909,
	"./GENESIS.png": 910,
	"./GHST.png": 911,
	"./GLINT.png": 912,
	"./GLMR.png": 913,
	"./GM.png": 914,
	"./GMT.svg": 915,
	"./GMX.png": 916,
	"./GNS.png": 917,
	"./GNT.png": 918,
	"./GOLDCOIN.svg": 919,
	"./GRAPE.png": 920,
	"./GUARD.svg": 921,
	"./HAI.png": 922,
	"./HARD.png": 923,
	"./HARMONY.svg": 924,
	"./HBAR.png": 925,
	"./HBTC.png": 926,
	"./HEC.png": 927,
	"./HECO.svg": 928,
	"./HERO.png": 929,
	"./HIGH.png": 930,
	"./HND.png": 931,
	"./HONEY.png": 932,
	"./HONOR.png": 933,
	"./HOTCROSS.svg": 934,
	"./HPS.png": 935,
	"./HT.png": 936,
	"./HTB.svg": 937,
	"./HUSD.png": 938,
	"./ICA.svg": 939,
	"./ICE.png": 940,
	"./IDIA.svg": 941,
	"./IF.svg": 942,
	"./IME.png": 943,
	"./INCH.png": 944,
	"./INJ.png": 945,
	"./INSUR.png": 946,
	"./INV.png": 947,
	"./IRON.png": 948,
	"./IXT.png": 949,
	"./JETS.png": 950,
	"./JEWEL.png": 951,
	"./JOE.png": 952,
	"./JPYC.png": 953,
	"./JRT.png": 954,
	"./JULD.png": 955,
	"./JUST.png": 956,
	"./KAE.png": 957,
	"./KART.png": 958,
	"./KEBAB.png": 959,
	"./KEK.png": 960,
	"./KIRO.png": 961,
	"./KLIMA.png": 962,
	"./KLO.png": 963,
	"./KRW.png": 964,
	"./LAC.svg": 965,
	"./LAMBDA.svg": 966,
	"./LAND.svg": 967,
	"./LAZIO.png": 968,
	"./LINEAR.svg": 969,
	"./LINK.png": 970,
	"./LINKe.png": 971,
	"./LIQ.png": 972,
	"./LITHIUM.svg": 973,
	"./LONG.png": 974,
	"./LOOT.png": 975,
	"./LOST.png": 976,
	"./LTC.svg": 977,
	"./LUNA.png": 978,
	"./MAGIC.png": 979,
	"./MAI.png": 980,
	"./MAI_Rose.png": 981,
	"./MANA.png": 982,
	"./MARSH.png": 983,
	"./MASK.svg": 984,
	"./MATIC.svg": 985,
	"./MCB.png": 986,
	"./MCRN.svg": 987,
	"./MDX.png": 988,
	"./MEAD.png": 989,
	"./MECHA.png": 990,
	"./MELT.png": 991,
	"./MERL.svg": 992,
	"./METAHERO.svg": 993,
	"./METIS.svg": 994,
	"./MIDAS.png": 995,
	"./MILK.png": 996,
	"./MIM.png": 997,
	"./MOBI.svg": 998,
	"./MONEY.png": 999,
	"./MOON.png": 1000,
	"./MOONBEAM.svg": 1001,
	"./MOONRIVER.svg": 1002,
	"./MORE.png": 1003,
	"./MOVR.png": 1004,
	"./MSC.png": 1005,
	"./MSS.png": 1006,
	"./MST.png": 1007,
	"./MULTI.png": 1008,
	"./MUST.png": 1009,
	"./MaticX.svg": 1010,
	"./NABOX.png": 1011,
	"./NAOS.png": 1012,
	"./NCASH.png": 1013,
	"./NEAR.svg": 1014,
	"./NETT.png": 1015,
	"./NEXO.png": 1016,
	"./NFT.png": 1017,
	"./NFTY.png": 1018,
	"./NUGGET.svg": 1019,
	"./NUTS.png": 1020,
	"./NYA.png": 1021,
	"./NYAC.png": 1022,
	"./NYAS.png": 1023,
	"./NZDS.png": 1024,
	"./O3.png": 1025,
	"./OASIS.svg": 1026,
	"./OCP.png": 1027,
	"./ONE.svg": 1028,
	"./ONG.svg": 1029,
	"./ONT.png": 1030,
	"./OOE.svg": 1031,
	"./ORBS.svg": 1032,
	"./ORKAN.png": 1033,
	"./OXD.png": 1034,
	"./PACOCA.svg": 1035,
	"./PAE.svg": 1036,
	"./PAE_AVAX.svg": 1037,
	"./PAUTO.png": 1038,
	"./PBNB.png": 1039,
	"./PEAR.svg": 1040,
	"./PEFI.png": 1041,
	"./PERA.png": 1042,
	"./PETS.png": 1043,
	"./PEX.png": 1044,
	"./PHA.png": 1045,
	"./PILLS.png": 1046,
	"./PMP.svg": 1047,
	"./PNG.png": 1048,
	"./POLYGON.svg": 1049,
	"./PORTO.png": 1050,
	"./POTS.png": 1051,
	"./PSP.png": 1052,
	"./PTP.png": 1053,
	"./PUP.png": 1054,
	"./PolyDoge.png": 1055,
	"./QBT.svg": 1056,
	"./QI.png": 1057,
	"./QUICK.png": 1058,
	"./QUIDD.png": 1059,
	"./RABBIT.svg": 1060,
	"./RACA.svg": 1061,
	"./RAMP.png": 1062,
	"./RELAY.png": 1063,
	"./REVV.svg": 1064,
	"./RIB.png": 1065,
	"./ROME.png": 1066,
	"./ROSE.png": 1067,
	"./ROUTE.png": 1068,
	"./RPG.png": 1069,
	"./SAGE.png": 1070,
	"./SAND.png": 1071,
	"./SANTOS.png": 1072,
	"./SBDO.png": 1073,
	"./SCREAM.png": 1074,
	"./SFP.png": 1075,
	"./SFUND.png": 1076,
	"./SHADE.png": 1077,
	"./SHIB.png": 1078,
	"./SHIBX.png": 1079,
	"./SHRAP.png": 1080,
	"./SING.png": 1081,
	"./SISTA.svg": 1082,
	"./SKILL.svg": 1083,
	"./SKY.svg": 1084,
	"./SMART.png": 1085,
	"./SNX.png": 1086,
	"./SOAK.png": 1087,
	"./SOL.png": 1088,
	"./SOLACE.png": 1089,
	"./SOLAR.png": 1090,
	"./SOLID.svg": 1091,
	"./SPADE.png": 1092,
	"./SPELL.png": 1093,
	"./SPIRIT.png": 1094,
	"./SPS.svg": 1095,
	"./STARS.svg": 1096,
	"./START.png": 1097,
	"./STATIC.png": 1098,
	"./STEAK.png": 1099,
	"./STEEL.png": 1100,
	"./STELLA.png": 1101,
	"./STNEAR.png": 1102,
	"./SUMMIT.png": 1103,
	"./SUSHI.png": 1104,
	"./SUSHIe.png": 1105,
	"./SWAMP.svg": 1106,
	"./SX.png": 1107,
	"./SXP.svg": 1108,
	"./SYN.svg": 1109,
	"./TAPE.svg": 1110,
	"./TEL.png": 1111,
	"./TENFI.png": 1112,
	"./TETHYS.svg": 1113,
	"./TETU.svg": 1114,
	"./THG.png": 1115,
	"./TIME.png": 1116,
	"./TITAN.svg": 1117,
	"./TLOS.svg": 1118,
	"./TOMB.png": 1119,
	"./TONIC.svg": 1120,
	"./TOR.svg": 1121,
	"./TREEB.png": 1122,
	"./TRI.svg": 1123,
	"./TRX.png": 1124,
	"./TSHARE.svg": 1125,
	"./TUS.png": 1126,
	"./TUSD.png": 1127,
	"./TYPH.png": 1128,
	"./UFT.png": 1129,
	"./UNI.png": 1130,
	"./UNIe.png": 1131,
	"./USDB.png": 1132,
	"./USDC.svg": 1133,
	"./USDCe.svg": 1134,
	"./USDCm.svg": 1135,
	"./USDCs.svg": 1136,
	"./USDD.png": 1137,
	"./USDL.svg": 1138,
	"./USDO.png": 1139,
	"./USDT.svg": 1140,
	"./USDTe.svg": 1141,
	"./UST.png": 1142,
	"./UST_Rose.png": 1143,
	"./USTaxl.png": 1144,
	"./USTw.png": 1145,
	"./VALAS.svg": 1146,
	"./VERSA.svg": 1147,
	"./VOLT.png": 1148,
	"./VS.svg": 1149,
	"./VTX.png": 1150,
	"./VVS.svg": 1151,
	"./WAN.svg": 1152,
	"./WATCH.png": 1153,
	"./WAULTx.svg": 1154,
	"./WBNB.svg": 1155,
	"./WBTC.svg": 1156,
	"./WBTCe.svg": 1157,
	"./WBTCeth.svg": 1158,
	"./WCRO.svg": 1159,
	"./WETH.svg": 1160,
	"./WETHe.svg": 1161,
	"./WEX.svg": 1162,
	"./WEXpoly.png": 1163,
	"./WIGO.svg": 1164,
	"./WIN.png": 1165,
	"./WINE.png": 1166,
	"./WMATIC.svg": 1167,
	"./WMATIC_DFYN.svg": 1168,
	"./WMOVR_SUSHI.png": 1169,
	"./WOO.svg": 1170,
	"./WOOFY.png": 1171,
	"./WOOP.png": 1172,
	"./WSG.svg": 1173,
	"./WSTA.png": 1174,
	"./WUSD.svg": 1175,
	"./XAVA.png": 1176,
	"./XCV.svg": 1177,
	"./XRP.svg": 1178,
	"./XTZ.png": 1179,
	"./XVS.png": 1180,
	"./XWG.png": 1181,
	"./YAMP.svg": 1182,
	"./YEL.svg": 1183,
	"./YELD.png": 1184,
	"./YETI.png": 1185,
	"./YFI.png": 1186,
	"./YFIe.png": 1187,
	"./YGG.png": 1188,
	"./YOSHI.png": 1189,
	"./YUSD.png": 1190,
	"./YUZU.png": 1191,
	"./ZBTC.svg": 1192,
	"./ZETH.svg": 1193,
	"./ZOO.png": 1194,
	"./aBNBc.png": 1195,
	"./aQI.png": 1196,
	"./aROME.png": 1197,
	"./aUSDO.svg": 1198,
	"./aWOOL.png": 1199,
	"./agEUR.png": 1200,
	"./anyMTLX.png": 1201,
	"./asUSDC.png": 1202,
	"./axlATOM.png": 1203,
	"./bQI.png": 1204,
	"./bZoo.png": 1205,
	"./beFTM.svg": 1206,
	"./beJOE.png": 1207,
	"./beQI.png": 1208,
	"./binSPIRIT.svg": 1209,
	"./bscBUSD.svg": 1210,
	"./cEUR.png": 1211,
	"./cUSD.png": 1212,
	"./cakeHARD.png": 1213,
	"./cakeROOBEE.png": 1214,
	"./cakeSTAX.png": 1215,
	"./cakeTWT.png": 1216,
	"./cakebROOBEE.png": 1217,
	"./ceUSDC.svg": 1218,
	"./cxADA.png": 1219,
	"./cxBTC.png": 1220,
	"./cxDOGE.png": 1221,
	"./cxETH.png": 1222,
	"./evoBTC.svg": 1223,
	"./evoETH.svg": 1224,
	"./evoUSDC.svg": 1225,
	"./evoUSDT.svg": 1226,
	"./fUSD.png": 1227,
	"./fUSDT.png": 1228,
	"./fWINGS.svg": 1229,
	"./gOHM.png": 1230,
	"./ibBTC.svg": 1231,
	"./ironICE.svg": 1232,
	"./jCHF.png": 1233,
	"./jEUR.png": 1234,
	"./jGBP.png": 1235,
	"./jJPY.png": 1236,
	"./jNZD.svg": 1237,
	"./mUSDC.svg": 1238,
	"./mUSDT.svg": 1239,
	"./miMatic.png": 1240,
	"./newQUICK.svg": 1241,
	"./pAVAX.svg": 1242,
	"./pBNB.svg": 1243,
	"./pBREW.png": 1244,
	"./pFTM.svg": 1245,
	"./pMATIC.svg": 1246,
	"./pOPEN.png": 1247,
	"./pWINGS.png": 1248,
	"./polyBUNNY.png": 1249,
	"./polyWISE.png": 1250,
	"./rUSD.svg": 1251,
	"./renBTC.png": 1252,
	"./renBTC.svg": 1253,
	"./renDGB.svg": 1254,
	"./renDOGE.png": 1255,
	"./sALPACA.svg": 1256,
	"./sAVAX.png": 1257,
	"./sFTMx.png": 1258,
	"./sSPELL.png": 1259,
	"./stKSM.png": 1260,
	"./stMATIC.png": 1261,
	"./wMEMO.png": 1262,
	"./wsHEC.png": 1263,
	"./wsSPA.png": 1264,
	"./xBOO.png": 1265,
	"./xMARK.png": 1266,
	"./xSCREAM.png": 1267,
	"./xTRI.svg": 1268,
	"./xVOLT.svg": 1269,
	"./xYELD.svg": 1270,
	"./xcDOT.png": 1271,
	"./xcKSM.png": 1272,
	"./xcRMRK.png": 1273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2070;